import { Button, Flex, Grid, Menu, Text } from "@mantine/core";
import { IconChevronDown, type TablerIcon } from "@tabler/icons-react";
import { Children, cloneElement, isValidElement, type ReactElement } from "react";

export function GridMenu({
  id,
  label,
  icon,
  tooltip,
  children,
  width = 250,
  disabled = false,
}: {
  id: string;
  label: string;
  icon: TablerIcon;
  tooltip: string;
  children?: React.ReactNode;
  width?: number;
  disabled?: boolean;
}) {
  const Icon = icon;

  const buttonColor = disabled
    ? "var(--mantine-color-gray-6)"
    : "var(--mantine-color-dark-6)";

  return (
    <Menu
      shadow="lg"
      withArrow
      offset={0}
      position="bottom"
      closeOnItemClick={true}
      disabled={disabled}
      width={width}
      zIndex={100}
    >
      <Menu.Target>
        <Button
          c={buttonColor}
          variant="white"
          h="100%"
          px="sm"
          opacity={disabled ? 0.5 : 1}
        >
          <Flex direction="column" align="center" justify="center" gap={4}>
            <Flex align="center" gap={2} pl={10}>
              <Icon size={22} stroke={1.2} />
              <IconChevronDown size={10} />
            </Flex>
            <Text fw={400} fz={13}>
              {label}
            </Text>
          </Flex>
        </Button>
      </Menu.Target>
      <Menu.Dropdown p={4}>
        <Menu.Label ta="center" tt="uppercase" fw={600} py={10}>
          {tooltip}
        </Menu.Label>
        <Grid gutter={4} w="100%" p={0} pb={4}>
          {Children.toArray(children)
            .filter((child): child is ReactElement => isValidElement(child))
            .map((child) => {
              const element = child as ReactElement<{
                id: string;
                fullWidth?: boolean;
                parentId?: string;
              }>;
              return (
                <Grid.Col key={element.key || element.props.id} span={4}>
                  {cloneElement(element, {
                    fullWidth: true,
                    parentId: id,
                  })}
                </Grid.Col>
              );
            })}
        </Grid>
      </Menu.Dropdown>
    </Menu>
  );
}
